import { Component, inject } from '@angular/core';
import { AbstractComponent } from './abstract.component';
import { Metadata } from '../models/sys/metadata';
import { AppStateService } from '../services/app-state.service';

@Component({
  template: '',
})
export abstract class PageComponent extends AbstractComponent {
  protected readonly _appState: AppStateService = inject(AppStateService);

  protected abstract get metadata(): Metadata;

  protected onMetadata(): void {
    this._appState.metadata = this.metadata;
  }
}
